import { render, staticRenderFns } from "./LayerLabel.vue?vue&type=template&id=706c6b5a&"
import script from "./LayerLabel.vue?vue&type=script&lang=js&"
export * from "./LayerLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports